import {
  ChangeDetectionStrategy,
  Component,
  computed,
  CUSTOM_ELEMENTS_SCHEMA,
  ElementRef,
  inject,
  input,
  OnDestroy,
  signal,
  ViewChild,
} from '@angular/core';
import { JsonPipe } from '@angular/common';
import { Subscription } from 'rxjs';
import { PayoutsService } from '@/app/services/payouts/payouts.service';

@Component({
  selector: 'ao-atom-airwallex-transaction-details',
  imports: [JsonPipe],
  templateUrl: './airwallex-transaction-details.html',
  styleUrl: './airwallex-transaction-details.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AirwallexTransactionDetails implements OnDestroy {
  @ViewChild('airwallexTransactionDetailsDialog', { static: false })
  airwallexTransactionDetailsDialog?: ElementRef<HTMLDialogElement>;

  attemptAirWallexId = input<string | undefined>();
  attemptId = input<string | undefined>();

  private payoutsService = inject(PayoutsService);
  private subscriptionList = new Subscription();

  airwallexTransfer = signal<unknown | undefined>(undefined);

  dialogId = computed(() => `airwallex-transaction-details-${this.attemptId() ?? 'unknown'}`);
  titleId = computed(() => `${this.dialogId()}-title`);

  findTransactionDetails(): void {
    console.log('findTransactionDetails', this.attemptAirWallexId());
    this.airwallexTransfer.set(undefined);

    const transferId = this.attemptAirWallexId();
    if (transferId) {
      this.subscriptionList.add(
        this.payoutsService.getAirwallexTransferById(transferId).subscribe({
          next: (res) => this.airwallexTransfer.set(res),
          error: () => this.airwallexTransfer.set(undefined),
        }),
      );
    }

    this.airwallexTransactionDetailsDialog?.nativeElement?.showModal();
  }

  closeDrawer(): void {
    this.airwallexTransactionDetailsDialog?.nativeElement?.close();
  }

  ngOnDestroy(): void {
    this.subscriptionList.unsubscribe();
  }
}
